var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playing-card",class:[
    `suit-${_vm.card.suit.name}`,
    _vm.size,
    { 'is-red': _vm.card.suit.color === 'red', 'is-black': _vm.card.suit.color === 'black', 'selected': _vm.selected, 'face-down': _vm.faceDown, 'is-mobile': _vm.isMobile }
  ],on:{"click":_vm.handleClick,"touchstart":_vm.handleTouchStart,"dblclick":_vm.handleDblclick}},[(!_vm.faceDown)?[_c('div',{staticClass:"card-front-sprite",style:(_vm.cardSpriteStyle)})]:[_c('div',{staticClass:"card-back"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }